import { Component, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { LoanTermPipe } from '@app/pipes/loan-term.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-features',
  imports: [TranslatePipe, LoanTermPipe],
  templateUrl: './project-details-features.component.html',
  styleUrl: './project-details-features.component.scss',
})
export class ProjectDetailsFeaturesComponent {
  readonly projectDetails = input.required<ProjectPublicResponse>();

  getDateString(date: Date | string): string {
    return new Date(date).toLocaleDateString();
  }
}
